import { render, staticRenderFns } from "./AttachmentSelector.vue?vue&type=template&id=2a0d0a92&scoped=true"
import script from "./AttachmentSelector.vue?vue&type=script&lang=js"
export * from "./AttachmentSelector.vue?vue&type=script&lang=js"
import style0 from "./AttachmentSelector.vue?vue&type=style&index=0&id=2a0d0a92&prod&lang=css"
import style1 from "./AttachmentSelector.vue?vue&type=style&index=1&id=2a0d0a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d0a92",
  null
  
)

export default component.exports